/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Apikeys_Create_Api_Key_SuccessInputs */



/**
* | output |
* | --- |
* | "API key created successfully!" |
*
* @param {Apikeys_Create_Api_Key_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const apikeys_create_api_key_success = /** @type {((inputs?: Apikeys_Create_Api_Key_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Apikeys_Create_Api_Key_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("API-Schlüssel erfolgreich erstellt!")
	return /** @type {LocalizedString} */ ("API key created successfully!")
});